export default "__VITE_ASSET__ce0e33c4__"